// DATI DEL SITO RED STONE - modifica qui i contenuti, poi esegui: yarn build
export const siteSettings = {
  "phone": "0775 327702",
  "whatsapp": "3349408506",
  "email": "",
  "address": "Via Giacomo Matteotti, 398",
  "city": "03023 Ceccano (FR)",
  "hours": [
    "Lunedì: Chiuso",
    "Martedì – Domenica: aperti a cena"
  ],
  "instagram": "https://instagram.com/redstonepubceccano?dlrf=MXA5NXJkZzJyazN3cg%3D%3D",
  "facebook": "https://www.facebook.com/share/19kRoRBXS6/?mibextid=wwXIfr",
  "notice": "",
  "maps_query": "Red Stone, Via Giacomo Matteotti 398, 03023 Ceccano FR",
  "hero_image": "/assets/hero.jpg",
  "about_image": "/assets/locale.jpg",
  "about_text": "Un bar, un ristopub e una pizzeria nella zona di Ceccano. Il posto dove incontrarsi dopo una giornata lunga, condividere una pizza con gli amici, brindare a qualcosa di bello e restare a chiacchierare fino a tardi. Informale ma curato, giovane ma accogliente per tutti: al Red Stone ogni serata trova il suo tavolo."
};
